export default __webpack_public_path__ + "static/media/eb-pro-wht-poster-3.34558670.jpg";